// SD product lists saved in the browser: wishlist hearts ([data-sd-wish]) and compare checkboxes
// ([data-sd-compare], max 4), plus the Theme Editor tile preview. Loaded once, event-delegated.
(() => {
  if (window.sdRangesInit) return;
  window.sdRangesInit = true;

  const WISH = 'sd:wishlist';
  // Per saved handle: { t: saved at (ms), p: price when saved (pence), v: variant id }, for the wishlist page
  const WISH_META = 'sd:wishlist:meta';
  const COMPARE = 'sd:compare';
  // Max from the Compare section (sections/sd-compare.liquid, data-max), else 4
  const compareMax = () => Number(document.querySelector('sd-compare[data-max]')?.dataset.max) || 4;

  const read = (key) => {
    try {
      return new Set(JSON.parse(localStorage.getItem(key)) || []);
    } catch {
      return new Set();
    }
  };

  const write = (key, items) => {
    try {
      localStorage.setItem(key, JSON.stringify([...items]));
    } catch {
      // Storage blocked (private mode): the toggle still works for this page view.
    }
  };

  // Unchecked compare boxes are disabled once the list is full.
  const syncCompare = (root, saved) => {
    root.querySelectorAll('[data-sd-compare]').forEach((box) => {
      box.checked = saved.has(box.dataset.sdCompare);
      box.disabled = !box.checked && saved.size >= compareMax();
    });
  };

  const sync = (root = document) => {
    const wished = read(WISH);
    root.querySelectorAll('[data-sd-wish]').forEach((btn) => {
      btn.setAttribute('aria-pressed', String(wished.has(btn.dataset.sdWish)));
    });
    syncCompare(root, read(COMPARE));
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-sd-wish]');
    if (!btn) return;

    const id = btn.dataset.sdWish;
    const saved = read(WISH);
    const on = !saved.has(id);
    if (on) saved.add(id);
    else saved.delete(id);
    write(WISH, saved);

    let meta = {};
    try {
      meta = JSON.parse(localStorage.getItem(WISH_META)) || {};
    } catch {
      meta = {};
    }
    if (on) {
      meta[id] = {
        t: Date.now(),
        p: Number(btn.dataset.sdWishPrice) || 0,
        v: Number(btn.dataset.sdWishVariant) || 0,
      };
    } else {
      delete meta[id];
    }
    try {
      localStorage.setItem(WISH_META, JSON.stringify(meta));
    } catch {
      // Storage blocked: the heart still toggles for this page view.
    }

    document.querySelectorAll('[data-sd-wish]').forEach((el) => {
      if (el.dataset.sdWish === id) el.setAttribute('aria-pressed', String(on));
    });
    // source: the clicked heart, so the toast can show that card's name and image
    const detail = { id, on, items: [...saved], source: btn };
    document.dispatchEvent(new CustomEvent('sd:wishlist', { detail }));
    // Generic alias for widgets that don't know the sd: namespace
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail }));
  });

  document.addEventListener('change', (event) => {
    const box = event.target.closest?.('[data-sd-compare]');
    if (!box) return;

    const id = box.dataset.sdCompare;
    const saved = read(COMPARE);
    if (box.checked && saved.size < compareMax()) saved.add(id);
    else saved.delete(id);
    write(COMPARE, saved);

    syncCompare(document, saved);
    document.dispatchEvent(
      new CustomEvent('sd:compare', { detail: { id, on: saved.has(id), items: [...saved], max: compareMax() } })
    );
  });

  // Theme Editor re-renders and collection filter/sort updates replace cards: re-sync them.
  document.addEventListener('shopify:section:load', (event) => sync(event.target));
  document.addEventListener('facets:rendered', () => sync());
  // The compare bar changed the list (remove / clear all): re-tick the boxes
  document.addEventListener('sd:compare:sync', () => sync());
  document.addEventListener('shopify:block:select', (event) => {
    event.target.closest?.('.sd-tile')?.classList.add('is-active');
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    event.target.closest?.('.sd-tile')?.classList.remove('is-active');
  });

  sync();
})();
